export default {"src":"/_next/static/media/ssa-logo-on-white.f8ca5319.svg","height":27,"width":145,"blurWidth":0,"blurHeight":0};